var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.377 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H21.377C21.1316 13.0004 20.9228 13.1787 20.884 13.421C20.2641 17.2568 17.2568 20.2641 13.421 20.884C13.1787 20.9228 13.0004 21.1316 13 21.377V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V21.377C10.9996 21.1316 10.8213 20.9228 10.579 20.884C6.74321 20.2641 3.73588 17.2568 3.116 13.421C3.07723 13.1787 2.86837 13.0004 2.623 13H1C0.447716 13 0 12.5523 0 12C0 11.4477 0.447716 11 1 11H2.623C2.86837 10.9996 3.07723 10.8213 3.116 10.579C3.73588 6.74321 6.74321 3.73587 10.579 3.116C10.8213 3.07722 10.9996 2.86838 11 2.623V1C11 0.447708 11.4477 0 12 0C12.5523 0 13 0.447708 13 1V2.623C13.0004 2.86838 13.1787 3.07722 13.421 3.116C17.2568 3.73587 20.2641 6.74321 20.884 10.579C20.9228 10.8213 21.1316 10.9996 21.377 11ZM5 12C5 15.866 8.13401 19 12 19C15.8642 18.9956 18.9956 15.8642 19 12C19 8.134 15.866 5 12 5C8.13401 5 5 8.134 5 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8b112d19.svg";
export { ForwardRef as ReactComponent };